import axiosIns from "@/api/axios";

export const GET_LIST = (params) => {
    return axiosIns.get("/notification/marquee-text");
};

export const CREATE = (payload) => {
    return axiosIns.post("/notification/marquee-text", payload);
};

export const UPDATE = (args) => {
    return axiosIns.put(`/notification/marquee-text/${args.id}`, args);
};

export const DELETE = (id) => {
    return axiosIns.delete(`/notification/marquee-text/${id}`);
};